<template>
  <v-dialog v-model="dialog" :max-width="800">
    <v-card>
      <v-card-title class="headline">
        Pagamento PIX
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="$emit('close')">
          <i class="close icon large"></i>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div v-for="(item, index) in listaQrCode" :key="index" class="ui segment">
          <div class="ui center aligned segment">
            <h2 class="ui header">
              Transferir <span style="color: #1BA1E2;">R$ {{ formatarMoeda(item.valor) }}</span> para concluir sua compra.
            </h2>
          </div>
          <div class="ui two column grid">
            <div class="column">
              <div class="ui segment">
                <h4 class="ui header">Dados do vendedor:</h4>
                <div class="ui relaxed list">
                  <div class="item">
                    <strong>Razão Social:</strong> {{ dadosEmpresa.razaosocial || '' }}
                  </div>
                  <div class="item">
                    <strong>Nome fantasia:</strong> {{ dadosEmpresa.nomefantasia || '' }}
                  </div>
                  <div class="item">
                    <strong>CNPJ:</strong> {{ dadosEmpresa.cnpj || '' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="column center aligned">
              <div class="ui segment">
                <h4>1. Chave "QR-Code"</h4>
                <img :src="item.link" alt="QR Code PIX" style="width: 200px; height: 200px; margin: 20px auto;">
              </div>
            </div>
          </div>
          <div class="ui segment">
            <h4>2. Chave "Copia e Cola"</h4>
            <div class="ui form">
              <div class="field">
                <div class="ui fluid input">
                  <input
                    type="text"
                    :value="item.emv"
                    readonly
                    style="font-family: monospace; font-size: 11px; color: #666; background-color: #f8f8f8;"
                    placeholder="Código PIX será exibido aqui..."
                  >
                </div>
                <br>
                <div class="ui two column grid">
                  <div class="column">
                    <button
                      type="button"
                      class="ui primary fluid button large"
                      @click="$emit('copiar-pix', item.emv)"
                      style="background-color: #1BA1E2 !important;"
                    >
                      <i class="copy icon"></i>
                      Copiar chave PIX
                    </button>
                  </div>
                  <div class="column">
                    <button
                      type="button"
                      class="ui green fluid button large"
                      @click="$emit('gerar-link-seguro', item)"
                      style="background-color: #25D366 !important;"
                    >
                      <i class="linkify icon"></i>
                      Gerar Link Seguro
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="ui info message" style="margin-top: 20px;">
              <i class="info circle icon"></i>
              Verifique o valor antes de confirmar o pagamento
            </div>
          </div>
          <div class="ui center aligned segment" style="color: #999; font-size: 12px;">
            Gerado em: {{ new Date().toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }) }}
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="$emit('close')">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import numeral from 'numeral';

export default {
  name: 'PixSeguro',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    listaQrCode: {
      type: Array,
      default: () => [],
    },
    dadosEmpresa: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatarMoeda(valor) {
      return numeral(parseFloat(valor)).format('0,0.00');
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .ui.two.column.grid {
    display: block !important;
  }
  .column {
    width: 100% !important;
    margin-bottom: 20px;
  }
}

.codigo-pix-input {
  word-break: break-all;
  font-size: 11px !important;
  line-height: 1.4;
  padding: 10px !important;
  min-height: 60px;
  resize: none;
}
</style>
